// IndexedDB local-first store for Acuman
const DB_NAME = "synapse_db";
const VERSION = 1;

function open() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, VERSION);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains("sessions")) {
        const store = db.createObjectStore("sessions", { keyPath: "id" });
        store.createIndex("createdAt", "createdAt");
      }
      if (!db.objectStoreNames.contains("meta")) {
        db.createObjectStore("meta", { keyPath: "key" });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function tx(store, mode, fn) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const t = db.transaction(store, mode);
    const s = t.objectStore(store);
    const res = fn(s);
    t.oncomplete = () => resolve(res._result !== undefined ? res._result : res);
    t.onerror = () => reject(t.error);
  });
}

function reqToPromise(request) {
  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function saveSession(session) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const t = db.transaction("sessions", "readwrite");
    t.objectStore("sessions").put(session);
    t.oncomplete = () => resolve(session);
    t.onerror = () => reject(t.error);
  });
}

export async function getAllSessions() {
  const db = await open();
  return new Promise((resolve, reject) => {
    const t = db.transaction("sessions", "readonly");
    const req = t.objectStore("sessions").getAll();
    req.onsuccess = () => {
      const arr = req.result || [];
      arr.sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
      resolve(arr);
    };
    req.onerror = () => reject(req.error);
  });
}

export async function getSession(id) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const t = db.transaction("sessions", "readonly");
    const req = t.objectStore("sessions").get(id);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function deleteSession(id) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const t = db.transaction("sessions", "readwrite");
    t.objectStore("sessions").delete(id);
    t.oncomplete = () => resolve();
    t.onerror = () => reject(t.error);
  });
}

export async function getMeta(key, def = null) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const t = db.transaction("meta", "readonly");
    const req = t.objectStore("meta").get(key);
    req.onsuccess = () => resolve(req.result ? req.result.value : def);
    req.onerror = () => reject(req.error);
  });
}

export async function setMeta(key, value) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const t = db.transaction("meta", "readwrite");
    t.objectStore("meta").put({ key, value });
    t.oncomplete = () => resolve();
    t.onerror = () => reject(t.error);
  });
}

export async function exportAll() {
  const sessions = await getAllSessions();
  const unlocked = await getMeta("unlocked", false);
  const voice = await getMeta("voice", null);
  return { app: "Acuman", exportedAt: new Date().toISOString(), sessions, settings: { unlocked, voice } };
}
